import { StyledPlanillas } from "../../styled/Planillas";

const TableTitle = ({ title }) => {
  return (
    <StyledPlanillas.GrupoTitulo variant="h6">
      {title}
    </StyledPlanillas.GrupoTitulo>
  );
};

export default TableTitle;
